import React from 'react';
import { QuoteIcon, StarIcon } from 'lucide-react';
import { featuredTestimonial } from '../data/content';
import { Reveal } from './Reveal';
export function TestimonialsSection() {
  const {
    quote,
    initials,
    name,
    role
  } = featuredTestimonial;
  return <section className="w-full border-y border-white/5 bg-steel-900 px-6 py-16 sm:py-20" aria-labelledby="testimonial-title" data-id="element-194" data-mp="1my7oizsej3sy">
      <div className="mx-auto max-w-3xl text-center" data-id="element-195" data-mp="1d1bgev6f0jox">
        <h2 id="testimonial-title" className="font-display text-xs font-semibold uppercase tracking-[0.24em] text-circuit-300" data-id="element-196" data-mp="1d3xn6slhev63">
          Real success from real instructors
        </h2>

        <Reveal className="mt-8" data-id="element-197" data-mp="142zgu3nkmbkc">
          <QuoteIcon className="mx-auto h-8 w-8 text-ember-500/50" aria-hidden="true" data-id="element-198" data-mp="182rv8wznbbxm" />
          <blockquote className="mt-5 font-display text-2xl font-medium leading-snug text-ink-50 sm:text-3xl" data-id="element-199" data-mp="184kzk5msdk2g">
            “{quote}”
          </blockquote>

          <div className="mt-8 flex items-center justify-center gap-4" data-id="element-200" data-mp="32fhp5eq0kl50">
            <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-ember-500 font-display text-sm font-bold text-steel-950" data-id="element-201" data-mp="2v12ppay0r1fx">
              {initials}
            </span>
            <div className="text-left" data-id="element-202" data-mp="34rxcqhj3a52f">
              <p className="font-display text-base font-semibold uppercase tracking-wide text-ink-50" data-id="element-203" data-mp="34qm689y9ej7m">
                {name}
              </p>
              <p className="text-sm text-ink-400" data-id="element-204" data-mp="2c2gjjhnnak55">{role}</p>
            </div>
            <span className="flex gap-0.5" aria-label="Rated 5 out of 5" data-id="element-205" data-mp="2c4jkgwqc5xon">
              {[0, 1, 2, 3, 4].map(i => <StarIcon key={i} className="h-4 w-4 fill-ember-400 text-ember-400" aria-hidden="true" data-id="element-206" data-mp="275zyiwbqslwa" />)}
            </span>
          </div>
        </Reveal>
      </div>
    </section>;
}